import React from 'react';
import PropTypes from 'prop-types';
import './VersionHistory.css';
import { readSnapshot, hasSnapshot } from '../../utils/versionHistory';

const VersionHistory = ({ versionHistory, currentVersion, currentAuthor, onViewVersion, viewingVersion, onExitVersionView, onResizeMouseDown, panelRef }) => {
  const history = Array.isArray(versionHistory) ? versionHistory : [];

  if (history.length === 0) return null;

  const handleViewClick = (entry) => {
    const xml = readSnapshot(entry);
    if (xml && onViewVersion) {
      onViewVersion(xml, entry.version, entry.images);
    }
  };

  const reversed = [...history].reverse();

  // Compute row className without nested ternary
  const getRowClassName = (isViewing, idx) => {
    if (isViewing) return 'vhp-viewing-row';
    if (idx === 0 && !viewingVersion) return 'vhp-current-row';
    return '';
  };

  return (
    <div className="version-history-panel" ref={panelRef}>
      {onResizeMouseDown && (
        <button
          type="button"
          className="vhp-resize-handle"
          aria-label="Historiengröße anpassen"
          onMouseDown={onResizeMouseDown}
        >
          <span className="vhp-resize-handle-grip" />
        </button>
      )}
      <div className="version-history-panel-header">
        <span className="version-history-panel-title">
          <i className="bi bi-clock-history"></i> Bearbeitungshistorie
        </span>
        <span className="version-history-panel-current">
          Aktuelle Version: <strong>v{currentVersion || '1.0'}</strong> — {currentAuthor || '—'}
        </span>
      </div>
      <div className="version-history-panel-body">
        <table className="version-history-panel-table">
          <thead>
            <tr>
              <th>Version</th>
              <th>Bearbeitet von</th>
              <th>Kommentar</th>
              <th>Datum</th>
              <th style={{ width: '40px' }}></th>
            </tr>
          </thead>
          <tbody>
            {/* "Aktueller Stand" row — shown when viewing a historic version */}
            {viewingVersion && onExitVersionView && (
              <tr className="vhp-current-stand-row">
                <td colSpan={4}>
                  <i className="bi bi-arrow-counterclockwise"></i>
                  {' '}Aktueller Stand <strong>(v{currentVersion || '1.0'})</strong>
                </td>
                <td>
                  <button
                    type="button"
                    className="vhp-view-btn vhp-view-btn-active"
                    onClick={onExitVersionView}
                    title="Zurück zum aktuellen Stand"
                  >
                    <i className="bi bi-eye"></i>
                  </button>
                </td>
              </tr>
            )}
            {reversed.map((entry, idx) => {
              const isViewing = viewingVersion
                ? entry.version === viewingVersion
                : idx === 0;
              const entryKey = `${entry.version}-${entry.date}-${idx}`;
              return (
                <tr key={entryKey} className={getRowClassName(isViewing, idx)}>
                  <td><strong>v{entry.version}</strong></td>
                  <td>{entry.author || '—'}</td>
                  <td className="vhp-comment-cell">{entry.comment || '—'}</td>
                  <td>{entry.date || '—'}</td>
                  <td>
                    {hasSnapshot(entry) && (
                      <button
                        type="button"
                        className={`vhp-view-btn ${isViewing ? 'vhp-view-btn-active' : ''}`}
                        onClick={() => handleViewClick(entry)}
                        title={`Version ${entry.version} anzeigen`}
                      >
                        <i className="bi bi-eye"></i>
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

VersionHistory.propTypes = {
  versionHistory: PropTypes.arrayOf(PropTypes.shape({
    version: PropTypes.string,
    author: PropTypes.string,
    date: PropTypes.string,
    comment: PropTypes.string,
    xml: PropTypes.string,
  })),
  currentVersion: PropTypes.string,
  currentAuthor: PropTypes.string,
  onViewVersion: PropTypes.func,
  viewingVersion: PropTypes.string,
  onExitVersionView: PropTypes.func,
  onResizeMouseDown: PropTypes.func,
  panelRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
};

export default VersionHistory;
